export type Nullable<T> = T | null | undefined;

export enum MODALS {
  LOGIN = 'login',
  CHANGE_PASSWORD = 'changePassword',
  REMOVE_POSITION = 'removePosition',
  REMOVE_DELAYED_SIGNAL = 'removeDelayedSignal',
  ANALYTIC = 'analytic',
  REMOVE_ANALYTIC = 'removeAnalytic',
  CHANGE_POSITION = 'changePosition',
  ACCOUNT_REBALANCE = 'accountRebalance',
  ACCOUNT_CALC_REBALANCE = 'accCalcRebalance',
  ACCOUNT_BLOCK = 'accountBlock',
  SERVICE_STOP_CS = 'serviceStop',
  COMMENT = 'comment',
}
